
/* ═══════════════════════════════════════════════
   TruSmile — Preguntas frecuentes
   assets/trusmile-faq.js
   Acordeón con animación suave. Soporta "una a la vez".
   ═══════════════════════════════════════════════ */
 
(function () {
  'use strict';
 
  function initFaq(root) {
    const single = root.dataset.single === 'true';
    const items = Array.prototype.slice.call(root.querySelectorAll('.tfaq__item'));
 
    function panel(item) { return item.querySelector('.tfaq__a'); }
 
    function setOpen(item, open) {
      const p = panel(item);
      const btn = item.querySelector('.tfaq__q');
      item.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', String(open));
      if (p) p.style.maxHeight = open ? (p.scrollHeight + 'px') : '0px';
    }
 
    // estado inicial (respeta las que vienen abiertas)
    items.forEach(function (item) { setOpen(item, item.classList.contains('is-open')); });
 
    root.addEventListener('click', function (e) {
      const btn = e.target.closest('.tfaq__q');
      if (!btn || !root.contains(btn)) return;
      const item = btn.closest('.tfaq__item');
      if (!item) return;
 
      const willOpen = !item.classList.contains('is-open');
      if (single && willOpen) {
        items.forEach(function (other) { if (other !== item) setOpen(other, false); });
      }
      setOpen(item, willOpen);
    });
 
    // reajuste al rotar / cambiar tamaño
    let rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        items.forEach(function (item) {
          if (item.classList.contains('is-open')) {
            const p = panel(item);
            if (p) p.style.maxHeight = p.scrollHeight + 'px';
          }
        });
      }, 150);
    });
  }
 
  function boot() {
    document.querySelectorAll('[data-tfaq]').forEach(initFaq);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();